<template>
    <a class="cart-menu-item" :href="cart.url" target="_blank">
        <img :style="styleObject" :src= cart.icon>
        <span>{{cart.name}}</span>
        <div>
            <span class="ci-count" id="shopping-amount">{{cartNum}}</span>
        </div>

    </a>
</template>
<script>
    export default {
        data(){
            return {
                
            }
        },
        computed: {
            styleObject: function () {
//                let data = this.$props.data;
                return {
                    /*'background-image': 'url(' + cart.icon + ')',*/
                    width: '18px',
                    height: '20px',
                    'margin-right': '8px ',
                    display: 'inline-block',
                    color : 'white'
                }
            },
            cartNum:function () {
                return this.$store.state.cartNum
            },
            cart:function(){
                return this.$store.state.malMainPageConfig.cart
            }
        }
    }
</script>

<style scoped lang="scss">
     .cart-menu-item {
        display: flex;
        align-items:center ;
        text-decoration: none;
        color: #ebeef5;
        font-family: PingFangSC-Regular;
        margin-left: 20px;
        font-size: 14px;
        letter-spacing: 0;
         position: relative;
         bottom:1px;
         line-height: 1;
    }
    .iconfont{
        color: #c81623;
        z-index: 999;
    }
    .ci-count{
        position: absolute;
        bottom: 12px;
        left: 10px;
        display: inline-block;
        padding: 1px 3px;
        font-size: 12px;
        line-height: 12px;
        color: #ebeef5;
        background-color: #e1251b;
        border-radius: 7px;
        min-width: 12px;
        text-align: center;
    }
</style>
